import {
  BrowserRouter, Routes, Route, useLocation,
} from 'react-router-dom';
import { ScrollToTop, RemoteSync } from 'components';
import {
  NotFound,
  Players,
  Scoreboard,
  History,
  Draft,
  UpdateStore,
  Admin,
  RemoteControl,
  RemoteWatch,
} from 'pages';

// O app é a fonte da verdade do controle remoto — ativo em qualquer aba, exceto no próprio /remote.
function RemoteSyncGate() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/remote')) return null;
  return <RemoteSync />;
}

export function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RemoteSyncGate />
      <Routes>
        <Route path="/scoreboard" element={<Scoreboard />} />
        <Route path="/" element={<Scoreboard />} />
        <Route path="/players" element={<Players />} />
        <Route path="/history" element={<History />} />
        <Route path="/players-ranking" element={<Players ranking />} />
        <Route path="/players-admin" element={<Players isAdmin />} />
        <Route path="/draft" element={<Draft />} />
        <Route path="/update-store" element={<UpdateStore />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/remote" element={<RemoteControl />} />
        <Route path="/remote-watch" element={<RemoteWatch />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
